export default function Marquee() {
    const items = [
        "AI Slop is the new Spam",
        "Visibility ≠ Authority",
        "Vanity Metrics are dead",
        "Earn the citation",
        "Narratives are infrastructure",
        "Reputation is compounding",
        "From the pixel to the podium",
    ];
    const all = [...items, ...items];
    return (
        <section
            data-testid="marquee"
            aria-hidden="true"
            className="relative border-y border-[#26262a] bg-[#050505] py-7 overflow-hidden"
        >
            <div className="flex whitespace-nowrap marquee-track">
                {all.map((t, i) => (
                    <span
                        key={i}
                        className="font-serif-display italic text-[clamp(1.6rem,3vw,2.6rem)] mx-8 text-[#a0a0ab]"
                    >
                        {t}
                        <span className="text-[#e6192b] mx-8">●</span>
                    </span>
                ))}
            </div>
        </section>
    );
}
